import { RSAA } from 'redux-api-middleware';

export const LOGOUT_REQUEST = '@@auth/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = '@@auth/LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = '@@auth/LOGOUT_FAILURE';

export const USER_PROFILE_REQUEST = '@@profile/USER_PROFILE_REQUEST';
export const USER_PROFILE_SUCCESS = '@@profile/USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAILURE = '@@profile/USER_PROFILE_FAILURE';

export const ME_REQUEST = '@@user/ME_REQUEST';
export const ME_SUCCESS = '@@user/ME_SUCCESS';
export const ME_FAILURE = '@@user/ME_FAILURE';

export const NOTIFICATION_REQUEST = '@@notification/NOTIFICATION_REQUEST';
export const NOTIFICATION_SUCCESS = '@@notification/NOTIFICATION_SUCCESS';
export const NOTIFICATION_FAILURE = '@@notification/NOTIFICATION_FAILURE';
export const SYSTEM_NOTIFICATION_RECEIVED =
  '@@notification/SYSTEM_NOTIFICATION_RECEIVED';

export const ACCOUNT_MOBILE_ACTIVATION_REQUEST =
  '@@auth/ACCOUNT_ACTIVATION_REQUEST';
export const ACCOUNT_MOBILE_ACTIVATION_SUCCESS =
  '@@auth/MOBILE_ACTIVATION_SUCCESS';
export const ACCOUNT_MOBILE_ACTIVATION_FAILURE =
  '@@auth/MOBILE_ACTIVATION_FAILURE';

export const RESET_ERROR_MESSAGE = '@err/RESET_ERROR_MESSAGE';
export const resetGlobalErrorMessage = () => ({
  type: RESET_ERROR_MESSAGE
});

export const logout = () => ({
  [RSAA]: {
    endpoint: '/api/auth/logout/',
    method: 'DELETE',
    types: [LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE]
  }
});

export const me = () => ({
  [RSAA]: {
    endpoint: '/api/users/me/',
    method: 'GET',
    types: [ME_REQUEST, ME_SUCCESS, ME_FAILURE]
  }
});

export const getUserProfileById = id => ({
  [RSAA]: {
    endpoint: `/api/users/${id}/profile/`,
    method: 'GET',
    types: [USER_PROFILE_REQUEST, USER_PROFILE_SUCCESS, USER_PROFILE_FAILURE]
  }
});

export const getNotifications = (offset = 0) => {
  return {
    [RSAA]: {
      endpoint: '/api/users/me/notifications/?offset=' + offset,
      method: 'GET',
      types: [NOTIFICATION_REQUEST, NOTIFICATION_SUCCESS, NOTIFICATION_FAILURE]
    }
  };
};

export const CLEAN_UP_PROFILE = '@@profile/CLEAN_UP';
export const cleanUpProfile = id => {
  return {
    type: CLEAN_UP_PROFILE,
    id
  };
};

export const activateAccountByMobileActivationCode = formData => ({
  [RSAA]: {
    endpoint: '/api/auth/activation/confirm/mobile/',
    method: 'POST',
    body: JSON.stringify(formData),
    types: [
      ACCOUNT_MOBILE_ACTIVATION_REQUEST,
      ACCOUNT_MOBILE_ACTIVATION_SUCCESS,
      ACCOUNT_MOBILE_ACTIVATION_FAILURE
    ]
  }
});

export const CREATE_DM_THREAD_REQUEST = '@@messenger/CREATE_DM_THREAD_REQUEST';
export const CREATE_DM_THREAD_SUCCESS = '@@messenger/CREATE_DM_THREAD_SUCCESS';
export const CREATE_DM_THREAD_FAILURE = '@@messenger/CREATE_DM_THREAD_FAILURE';
export const createDMThread = receiverId => {
  return {
    [RSAA]: {
      endpoint: `/api/threads/create_dm_thread/`,
      method: 'POST',
      body: JSON.stringify({
        receiver_id: receiverId
      }),
      types: [
        CREATE_DM_THREAD_REQUEST,
        CREATE_DM_THREAD_SUCCESS,
        CREATE_DM_THREAD_FAILURE
      ]
    }
  };
};
